import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faInstagram,
  faYoutube,
  faLinkedin,
  faFacebook,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./Main.css";

const Navbar = () => {
  const [mobile, setmobile] = useState(false);
  const [search, setsearch] = useState(false);
  const [homeDrop, sethomeDrop] = useState(false);
  const [headerDrop, setheaderDrop] = useState(false);
  const [servicesDrop, setservicesDrop] = useState(false);
  const [featuresDrop, setfeaturesDrop] = useState(false);
  const [newsDrop, setnewsDrop] = useState(false);
  const [pagesDrop, setpagesDrop] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const [menu, setmenu] = useState({});

  const activeMenu = () => {
    if (path === "/admin") {
      setmenu({ home: true });
    } else if (path === "/aboutusadmin") {
      setmenu({ about: true });
    } else if (path === "/serviceadmin" || path === "/servicedetailsadmin") {
      setmenu({ services: true });
    } else if (path === "/emicalculatoradmin") {
      setmenu({ emicalculator: true });
    } else if (path === "/preeligibilityadmin") {
      setmenu({ preeligibility: true });
    } else if (path === "/userlistadmin") {
      setmenu({ userlistadmin: true });
    } else if (path === "/loanapplicationadmin") {
      setmenu({ loanapplicationadmin: true });
    } else if (path === "/chatbotadmin") {
      setmenu({ chatbotadmin: true });
    } else if (path === "/leads") {
      setmenu({ leads: true });
    } else if (path === "/adminregister") {
      setmenu({ adminregister: true });
    } else if (path === "/addcomparison") {
      setmenu({ addcomparison: true });
    }
    if (path === "/createshop") {
      setmenu({ createshop: true });
    } else if (
      path === "/team" ||
      path === "/teamdetails" ||
      path === "/creditaudit" ||
      path === "/creditrepair" ||
      path === "/careers" ||
      path === "/faqs" ||
      path === "/applynow"
    ) {
      setmenu({ pages: true });
    } else if (
      path === "/personalloan" ||
      path === "/loaneligibility" ||
      path === "/homeloan" ||
      path === "/homeloaneligibility" ||
      path === "/compareEMI" ||
      path === "/monthlyloan"
    ) {
      setmenu({ features: true });
    } else if (path === "/newsmain" || path === "/newsdetails") {
      setmenu({ news: true });
    } else if (path === "/contactusadmin") {
      setmenu({ contact: true });
    } else {
      setmenu({ home: true });
    }
  };

  const [sticky, setSticky] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
    activeMenu();
  }, [path]);
  const isSticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 141 ? setSticky(true) : setSticky(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <nav
          className={`main-menu ${
            sticky && "stricky-header stricked-menu stricky-fixed"
          }`}
        >
          <div className="container-fluid">
            <div className="main-menu__logo">
              <Link to="/admin">
                <img
                  src="assets/images/mybankshoppylogo.png"
                  width="auto"
                  height="80"
                  alt="mybankshoppylogo"
                />
              </Link>
            </div>
            <div className="main-menu__nav" style={{ paddingLeft: "280px" }}>
              <ul className="main-menu__list newlist">
                <li className={`dropdown ${menu.home && "current"}`}>
                  <Link to="/admin">Home</Link>
                </li>

                <li className={`about ${menu.about && "current"}`}>
                  <Link to="/aboutusadmin">About</Link>
                </li>

                <li className={`service ${menu.services && "current"}`}>
                  <Link to="/serviceadmin">Services</Link>
                </li>
                <li className={`contact ${menu.contact && "current"}`}>
                  <Link to="/contactusadmin">Contact</Link>
                </li>
                <li
                  className={`userlistadmin ${menu.userlistadmin && "current"}`}
                >
                  <Link to="/userlistadmin">Enquiries</Link>
                </li>

                <li
                  className={`loanapplicationadmin ${
                    menu.loanapplicationadmin && "current"
                  }`}
                >
                  <Link to="/loanapplicationadmin">Applications</Link>
                </li>
                <li
                  className={`chatbotadmin ${menu.chatbotadmin && "current"}`}
                >
                  <Link to="/chatbotadmin">Chat</Link>
                </li>
                <li className={`leads ${menu.leads && "current"}`}>
                  <Link to="/leads">Leads</Link>
                </li>
                <li
                  className={`adminregister ${menu.adminregister && "current"}`}
                >
                  <Link to="/adminregister">Register</Link>
                </li>
                <li
                  className={`addcomparison ${menu.addcomparison && "current"}`}
                >
                  <Link to="/addcomparision">AdComparison</Link>
                </li>
                <li className={`createshop ${menu.createshop && "current"}`}>
                  <Link to="/createshop">Shop</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

      <div className={`search-popup ${search && "active"}`}>
        <div
          className="search-popup__overlay search-toggler"
          onClick={() => setsearch(false)}
        ></div>
        <div className="search-popup__content">
          <form action="#">
            <label htmlFor="search" className="sr-only">
              search here
            </label>
            <input type="text" id="search" placeholder="Search Here..." />
            <button
              type="submit"
              aria-label="search submit"
              className="thm-btn"
            >
              <i className="icon-magnifying-glass"></i>
            </button>
          </form>
        </div>
      </div>

      <div className={`mobile-nav__wrapper ${mobile ? "expanded" : ""}`}>
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={() => setmobile(false)}
        ></div>
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={() => setmobile(false)}
          >
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <Link to="/" aria-label="logo image">
              <img
                src="assets/images/mybankshoppylogo.png"
                width="155"
                alt=""
              />
            </Link>
          </div>

          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li className="dropdown current">
                <Link
                  to="/"
                  className={homeDrop ? "expanded" : ""}
                  onClick={() => setmobile(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setmobile(false)}>
                  About
                </Link>
              </li>
              <li className="dropdown">
                <Link
                  to="/service"
                  className={servicesDrop ? "expanded" : ""}
                  onClick={() => setmobile(false)}
                >
                  Services
                </Link>
              </li>

              <li>
                <Link to="/emicalculator" onClick={() => setmobile(false)}>
                  EMI Calculator
                </Link>
              </li>

              <li>
                <Link to="/preeligibility" onClick={() => setmobile(false)}>
                  Eligibility
                </Link>
              </li>

              <li>
                <Link to="/contact" onClick={() => setmobile(false)}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="icon-email"></i>
              <Link to="mailto:sales@mybankshoppy.com">
                sales@mybankshoppy.com
              </Link>
            </li>
            <li>
              <i className="icon-telephone"></i>
              <Link to="tel:+91 9884063673">+91 9884063673</Link>
            </li>
          </ul>

          <div className="mobile-nav__social">
            <Link to="#">
              <FontAwesomeIcon icon={faXTwitter} />
            </Link>
            <Link to="#">
              <FontAwesomeIcon icon={faInstagram} />
            </Link>
            <Link to="#">
              <FontAwesomeIcon icon={faYoutube} />
            </Link>
            <Link to="#">
              <FontAwesomeIcon icon={faLinkedin} />
            </Link>
            <Link to="#">
              <FontAwesomeIcon icon={faFacebook} />
            </Link>
            <Link to="#">
              <FontAwesomeIcon icon={faTwitter} />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
